import { createI18n } from 'vue-i18n'
import ko from './ko.json'
import en from './en.json'
import ja from './ja.json'
import zh from './zh.json'

const i18n = createI18n({
  legacy: true,
  locale: 'ko',
  fallbackLocale: 'en',
  messages: { ko, en, ja, zh }
})

export default i18n
